<script lang="ts">
	import PlayIcon from '$lib/components/Icon/PlayIcon.svelte';
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';
	import Button from '../../Button/Button.svelte';

	const { t } = getTranslate();

	export let additionalClass = '';
	export let trailerThumbnail: string = '';
	export let showThumbnail: boolean = true;
	export let showCenteredPlayButton: boolean = false;
</script>

{#if showThumbnail}
	<div
		on:click
		on:keypress
		class={classes(
			`cursor-pointer absolute h-full w-full flex flex-col space-y-8 justify-center items-center bg-svg ${
				trailerThumbnail !== '' ? 'bg-purple-tertiary' : 'bg-overlay-video bg-black'
			}`,
			additionalClass
		)}
		style={trailerThumbnail !== ''
			? `background-image: url(${trailerThumbnail}); background-size: 106% 111% !important; background-position: 50.5% 11%`
			: ''}
	>
		<h2 class="text-2xl text-center pt-4 md:pt-0 max-w-[75%]">
			{@html $t('trailer-overlay-start.text')}
		</h2>
		<!-- <Button additionalClass="cursor-pointer" on:click on:keypress>{$t('trailer-overlay-start.button.text')}</Button> -->
	</div>
{:else if showCenteredPlayButton}
	<div
		on:click
		on:keypress
		class="text-white w-full h-full flex flex-row justify-center items-center"
	>
		<PlayIcon />
	</div>
{/if}
